// @ts-nocheck

/**
 * * `bug` - Bug Report
 * `feature` - Feature Request
 * `general` - General Feedback
 */
export type FeedbackTypeEnum =
  typeof FeedbackTypeEnum[keyof typeof FeedbackTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackTypeEnum = {
  bug: "bug",
  feature: "feature",
  general: "general",
} as const;
